'use client';
import { jsx } from 'react/jsx-runtime';
import { useContext, createContext, useState, useMemo } from 'react';

const ZoomControlsContext = createContext({});
const ZoomControlsContextProvider = ({ children: t })=>{
    let [r, s] = useState(void 0), m = useMemo(()=>({
            id: r,
            setId: s
        }), [
        r,
        s
    ]);
    return jsx(ZoomControlsContext.Provider, {
        value: m,
        children: t
    });
};
const useZoomControlsContext = ()=>useContext(ZoomControlsContext);

export { ZoomControlsContext, ZoomControlsContextProvider, useZoomControlsContext };
